import $ from "jquery";

const SELECTORS = {
  form: ".umbraco-forms-form",
  navigation: ".umbraco-forms-navigation",
  resolver: ".js-resolve-self-help",
  selfHelpSection: ".selfhelpsection",
};

let currentlyVisible;

const instance = ($form: HTMLElement) => {
  const selfHelpSections = $form.querySelectorAll(SELECTORS.selfHelpSection);

  const fields = $form.querySelectorAll(
    `input:not([type="hidden"]), textarea, select`,
  );

  if (!selfHelpSections.length || !fields.length) {
    return;
  }

  const resolvers = document.querySelectorAll(SELECTORS.resolver);

  const checkSelfHelpVisibility = () => {
    let selfHelpVisible = false;
    selfHelpSections.forEach(($section: HTMLElement) => {
      if ($section.style.display !== "none") {
        selfHelpVisible = true;
        if ($section !== currentlyVisible) {
          currentlyVisible = $section;
          $form.classList.remove("selfhelp-resolved");

          resolvers.forEach(($resolver: HTMLElement) => {
            $resolver.classList.remove("btn--secondary");
            $resolver.classList.add("btn--tertiary");
            $resolver.classList.remove("selfhelp__resolved-by");

            const $field = document.getElementById(
              $resolver.dataset.for,
            ) as HTMLInputElement;
            $field.value = "";
            const event = new Event("change", {
              bubbles: true,
            });
            $field.dispatchEvent(event);
          });
        }
      }
    });

    if (selfHelpVisible) {
      $form.classList.add("selfhelp-visible");
    } else {
      $form.classList.remove("selfhelp-visible");
    }
  };

  // on change of any input/select/textarea, see if any self help sections are showing
  fields.forEach(($field: HTMLElement) => {
    $field.addEventListener("change", () => {
      // Because Umbraco hooks into the change event, our logic runs at the same time
      // but relies on the _outcome_ of Umbraco's change event. This zero time timeout forces it to evaluate afterwards.
      setTimeout(checkSelfHelpVisibility, 0);
    });
  });

  const resolveSelfHelp = () => {
    const $resolver = currentlyVisible.querySelector(SELECTORS.resolver);
    $resolver.classList.add("selfhelp__resolved-by");

    const $field = document.getElementById(
      $resolver.dataset.for,
    ) as HTMLInputElement;
    $field.value = $resolver.textContent.trim().toLowerCase();
    const event = new Event("change", {
      bubbles: true,
    });
    $field.dispatchEvent(event);

    // Delayed for CSS animation of 300ms on buttons
    setTimeout(() => {
      $resolver.classList.add("btn--secondary");
      $resolver.classList.remove("btn--tertiary");
    }, 300);

    $form.classList.add("selfhelp-resolved");
    return false;
  };

  resolvers.forEach(($resolver) => {
    $resolver.addEventListener("click", resolveSelfHelp);
  });
};

const selfHelpVisibility = () => {
  document.querySelectorAll(SELECTORS.form).forEach(($el: Element) => {
    const $htmlElement = $el as HTMLElement;

    instance($htmlElement);
  });
};

export default selfHelpVisibility;
